import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import compLine from "../Images/compLine.png";
import embed from "../Images/embedsw.jpeg";
import fs from "../Images/fs.jpg";
import "./IotSol_Details.css";

const sfd = "/static/media/sfd.c52dc87930ed00f51d32.jpg";
const qas = "/static/media/qas.24e1595dc0507ef8d2c2.jpg";
const pcb = "/static/media/pcb.b4e81f70fe3447d4eb3e.jpg";
const elect = "/static/media/elect.c001be2158e145c5a3a7.jpg";
const aut = "/static/media/aut.75ff39c5e75835a2ae76.jpg";
const hd = "/static/media/hd.7caec00bdf79de74ad8d.webp";
const iiotbanner = "/static/media/iiotbanner.e3385acd0283bfe386f0.jpg";

export default function IotSol_Details() {
  const arr = [
    {
      src: embed,
      head: "Embedded Engineering",
      para: "Embedded engineering for IIoT creates specialized hardware and software for seamless communication, real-time monitoring, and control in industrial environments.",
    },
    {
      src: sfd,
      head: "Software Development",
      para: "Expertise in software and firmware development for IIoT solutions, enabling seamless integration, data processing, and control in industrial environments.",
    },
    {
      src: qas,
      head: "Quality Assurance ",
      para: "Ensure robust, reliable performance, compliance, and security, enhancing industrial processes and operations.",
    },
    {
      src: pcb,
      head: "PCB Designing",
      para: " PCB design with real-time monitoring, automated testing, and data analytics, optimizing manufacturing processes and quality assurance.",
    },
    {
      src: hd,
      head: "Hardware Design",
      para: "Encompass instruments and software ensuring product quality, functionality, compliance, and adherence to industry standards.",
    },
    {
      src: aut,
      head: "Automotive Solution",
      para: "Automotive IIoT solutions integrate advanced sensors and data analytics, enhancing vehicle performance, safety, and maintenance in real time.",
    },
    {
      src: fs,
      head: "Testing Tools",
      para: "Enable virtual modeling and analysis, optimizing performance, efficiency, and decision-making in diverse industries and applications.",
    },
    {
      src: elect,
      head: "Electronic Manufacturing Services",
      para: "EMS provide end-to-end solutions, design, assembly, and testing, for electronic products in various industries.",
    },
  ];

  return (
    <>
      <Navbar />
      <div className="iotdetails__main">
        <div
          className="bg-primary with-background-image side-banner"
          style={{ backgroundImage: `url(${iiotbanner})` }}
        >
          <div className="wrap" style={{ marginLeft: "10%" }}>
            <div className="header-content">
              <h1>IIoT Solutions</h1>
              <br />
              <p>
                <span className="banner2">
                  Digital Intelligence to Discover Deep Business Insights &amp;
                  Transformative Strategy
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="auto__heading">
        <h2
          style={{
            color: "var(--color-blue)",
            textAlign: "left",
            marginLeft: "3em",
            marginBottom: "1rem",
          }}
        >
          IIoT SOLUTIONS
        </h2>
        <img src={compLine} alt="" />
      </div>

      <div className="autoDetails__cards">
        {arr.map((ele) => (
          <div className="card" key={ele.head} style={{ width: "18rem", height: "30rem" }}>
            <img
              className="card-img-top"
              src={ele.src}
              alt={ele.head}
              style={{ height: "19rem" }}
            />
            <div className="card-body">
              <strong>{ele.head}</strong>
              <p className="card-text" style={{ color: "black" }}>
                {ele.para}
              </p>
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
}
